export const PAYOUTS_RESET_STATE = 'PAYOUTS_RESET_STATE';
export const PAYOUTS_CURRENT_ITEM = 'PAYOUTS_CURRENT_ITEM';

export const PAYOUTS_REQUEST_LOADING = 'PAYOUTS_REQUEST_LOADING';
export const PAYOUTS_REQUEST_SUCCESS = 'PAYOUTS_REQUEST_SUCCESS';
export const PAYOUTS_REQUEST_FAILED = 'PAYOUTS_REQUEST_FAILED';

export const PAYOUTS_CURRENT_ACTION = 'PAYOUTS_CURRENT_ACTION';
export const PAYOUTS_RESET_ACTION = 'PAYOUTS_RESET_ACTION';